module.exports = __webpack_public_path__ + "img/icon_7.6e83c55c.png";